import { render, staticRenderFns } from "./tab8.vue?vue&type=template&id=62dab9b4&"
import script from "./tab8.vue?vue&type=script&lang=js&"
export * from "./tab8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports